import React from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { Provider } from "mobx-react";
import { Store } from "./store";
import * as serviceWorker from "./serviceWorker";
import Layout from "./Components/Layout/Layout";
import "./index.css";
import "animate.css";

const appStore = new Store();

ReactDOM.render(
  <Provider AppStore={appStore}>
    <Router>
      <Route path="/" component={Layout}></Route>
    </Router>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
